export const INPUT_CHANGE_DEBOUNCE_TIME = 500;
export const DEFAULT_MIN = 0;
export const DEFAULT_MAX = 11000;
